import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export function useSuperAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Se auth ainda está carregando, manter loading true
    if (authLoading) {
      setIsLoading(true);
      return;
    }

    // Se não há usuário, não é super admin
    if (!user) {
      setIsSuperAdmin(false);
      setIsLoading(false);
      return;
    }

    // Flag para evitar setState em componente desmontado
    let cancelled = false;

    async function checkSuperAdmin() {
      // Garantir loading true antes da query
      setIsLoading(true);

      try {
        const { data, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .eq('role', 'super_admin')
          .maybeSingle();

        if (cancelled) return;

        if (error) throw error;
        setIsSuperAdmin(!!data);
      } catch (error) {
        if (cancelled) return;
        console.error('Error checking super admin status:', error);
        setIsSuperAdmin(false);
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }

    checkSuperAdmin();

    return () => {
      cancelled = true;
    };
  }, [user, authLoading]);

  return { isSuperAdmin, isLoading };
}
